import { render } from "./ProfileLayout.vue?vue&type=template&id=45ba467d&scoped=true"
import script from "./ProfileLayout.vue?vue&type=script&lang=js"
export * from "./ProfileLayout.vue?vue&type=script&lang=js"

import "./ProfileLayout.vue?vue&type=style&index=0&id=45ba467d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/origins-userdash-v2/origins-userdash-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ba467d"]])

export default __exports__